import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Layout from './layout/Layout';
import Patios from './pages/gestion/PatiosClean';
import Personal from './pages/gestion/Personal';
import ContactosEmergencia from './pages/gestion/ContactosEmergencia';
import Asignacion from './pages/gestion/Asignacion';
import ReporteRondas from './pages/reportes/ReporteRondas';
import ReporteIncidencias from './pages/reportes/ReporteIncidencias';
import Rondas from './pages/gestion/Rondas';
// import VisitasPuntosControl from './pages/gestion/VisitasPuntosControl';
import Incidencias from './pages/gestion/Incidencias';
import SeguimientoUbicaciones from './pages/gestion/SeguimientoUbicaciones';
import AsignacionAutomatica from './pages/gestion/AsignacionAutomatica';
import RondasPlanificasVsCompletadas from './pages/reportes/RondasPlanificasVsCompletadas';
import ReporteTiempoPromedioXPuntosControl from './pages/reportes/ReporteTiempoPromedioXPuntosControl';
import ReporteIncidenciasTipoNivel from './pages/reportes/ReporteIncidenciasTipoNivel';
import RondasEnVivo from './pages/gestion/RondasEnVivo';

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="gestion">
          <Route path="rondas-en-vivo" element={<RondasEnVivo />} />
            <Route path="patios" element={<Patios />} />
            <Route path="personal" element={<Personal />} />
            <Route path="asignacion" element={<Asignacion />} />
            <Route path="asignacion-automatica" element={<AsignacionAutomatica />} />
            <Route path="contactos" element={<ContactosEmergencia />} />
            {/* <Route path="rondas" element={<Rondas />} /> */}
            {/* <Route path="visitas-puntos-control" element={<VisitasPuntosControl />} /> */}
            <Route path="incidencias" element={<Incidencias />} />
            <Route path="seguimiento-ubicaciones" element={<SeguimientoUbicaciones />} />
          </Route>
          <Route path="reportes">
            <Route path="rondas" element={<ReporteRondas />} />
            <Route path="incidencias" element={<ReporteIncidencias />} />
            <Route path="rondas-planificadas-vs-completadas" element={<RondasPlanificasVsCompletadas />} />
            <Route path="tiempo-promedio-puntos-control" element={<ReporteTiempoPromedioXPuntosControl />} />
            <Route path="incidencias-tiponivel" element={<ReporteIncidenciasTipoNivel />} />


          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
